import { api } from './api';
import type {
  LoginResponse,
  MessageResponse,
  PasswordResetValidationResponse,
  RefreshTokenResponse,
  RegisterResponse,
} from '@exhale/contracts';

class AuthService {
  async login(email: string, password: string): Promise<LoginResponse> {
    try {
      const response = await api.post<LoginResponse>('/auth/login', { email, password });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async register(
    email: string,
    password: string,
    firstName: string,
    lastName: string
  ): Promise<RegisterResponse> {
    return api.post<RegisterResponse>('/auth/register', {
      email,
      password,
      firstName,
      lastName,
    });
  }

  async logout(): Promise<MessageResponse> {
    return api.post<MessageResponse>('/auth/logout');
  }

  async refreshToken(token: string): Promise<RefreshTokenResponse> {
    return api.post<RefreshTokenResponse>('/auth/refresh-token', { token });
  }

  async changePassword(currentPassword: string, newPassword: string): Promise<MessageResponse> {
    return api.post<MessageResponse>('/auth/change-password', { currentPassword, newPassword });
  }

  async forgotPassword(email: string): Promise<MessageResponse> {
    return api.post<MessageResponse>('/auth/forgot-password', { email });
  }

  async validateResetToken(token: string): Promise<PasswordResetValidationResponse> {
    return api.get<PasswordResetValidationResponse>(`/auth/reset-password/${token}`);
  }

  async resetPassword(token: string, password: string): Promise<MessageResponse> {
    return api.post<MessageResponse>(`/auth/reset-password/${token}`, { password });
  }
}

export const authService = new AuthService();
